import { NodeModel } from "@minoru/react-dnd-treeview";
import { Box, Button, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { ErrorModal } from "../../../../../../../components/modals/error-modal";
import MesfModal from "../../../../../../../components/modals/modal.mesf";
import { ButtonWithLoading } from "../../../../../../../components/shared/buttons/button-with-loading";
import { TagFromTree } from "../../../models/TrendingModelsV2";
import {
	deleteTagFolder,
	upsertTagFolder,
} from "../../../repository/TrendingRepositoryV2";

interface Props {
	open: boolean;
	handleClose: (shouldUpdate: boolean) => void;
	tagNodeSelectedInTree: NodeModel<TagFromTree> | null;
}
export const RemoveFolderModal = ({
	open,
	handleClose,
	tagNodeSelectedInTree,
}: Props) => {
	const [error, setError] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const updateTagFolder = useMutation({
		mutationFn: upsertTagFolder,
		onError: (error: Error) => {
			setError(error.message);
		},
	});

	const removeFolder = useMutation({
		mutationFn: deleteTagFolder,

		onError: (error: Error) => {
			setError(error.message);
		},
	});

	const onSubmit = async (e: any) => {
		e.preventDefault();
		if (tagNodeSelectedInTree) {
			const parentId = Number(tagNodeSelectedInTree?.parent) || null;
			const name = tagNodeSelectedInTree?.text;
			const id = Number(tagNodeSelectedInTree?.id);
			setIsLoading(true);
			if (parentId) {
				await removeFolder.mutate(id);
			} else {
				await updateTagFolder.mutate({
					tagFolderId: id,
					parentTagFolderId: parentId,
					tagFolderName: name,
					isActive: false,
				});
			}
		}
		handleClose(true);
		setIsLoading(false);
	};

	return (
		<>
			<MesfModal
				open={open}
				handleClose={() => handleClose(false)}
				maxWidth={"lg"}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				title="Remove Folder"
			>
				<MesfModal.Content>
					<Box>
						<Typography>
							Are you sure you want to remove{" "}
							<strong>{tagNodeSelectedInTree?.text}</strong> folder?
						</Typography>
					</Box>
				</MesfModal.Content>
				<MesfModal.Actions>
					<div>
						<Button
							color="secondary"
							variant="outlined"
							onClick={() => handleClose(false)}
						>
							Cancel
						</Button>
					</div>
					<div>
						<ButtonWithLoading
							isLoading={isLoading}
							onClick={onSubmit}
							color="primary"
							variant="contained"
						>
							Remove
						</ButtonWithLoading>
					</div>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
